import { render, staticRenderFns } from "./SearchSelectDashboard.vue?vue&type=template&id=030a535e&"
import script from "./SearchSelectDashboard.vue?vue&type=script&lang=js&"
export * from "./SearchSelectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SearchSelectDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports